import { render, staticRenderFns } from "./LiveTradeCard.vue?vue&type=template&id=18a32496&scoped=true"
import script from "./LiveTradeCard.vue?vue&type=script&lang=js"
export * from "./LiveTradeCard.vue?vue&type=script&lang=js"
import style0 from "./LiveTradeCard.vue?vue&type=style&index=0&id=18a32496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a32496",
  null
  
)

export default component.exports